import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ValidationPatterns } from '../validation-patterns';
import { IValidationHandler, TValidatorError } from '../../model';

export function emailValidator(args: IValidationHandler): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const { value, invalid } = control;

    if (invalid) return null;

    if (!value) return null;

    const matchEmail = value.match(ValidationPatterns.email);

    if (!matchEmail?.length) {
      const vldResponse: TValidatorError = { email: value };
      return vldResponse;
    }

    return null;
  };
}
